<template>
    <div>
        <button @click="callApi">Call</button>
        <p>{{ apiMessage }}</p>
        <p>{{ token }}</p>
    </div>
</template>

<script>
// import axios from 'axios';
import {Authorizer} from '../auth/authorizer';

export default {
    name: "external-api",
    data() {
        return {
            apiMessage: "",
            token: ""
        };
    },
    methods: {
        // async callApi(){
        //     this.apiMessage = await this.$store.dispatch("authorize");
        // }
        async callApi() {
            let url = this.$store.state.authorizeUrl;
            var authorizer = new Authorizer(this.$auth, url);

            this.apiMessage = await authorizer.callApi();
            console.log(this.apiMessage);
            // // Get the access token from the auth wrapper
            // const token = await this.$auth.getTokenSilently();
            // this.token = token;

            // // Use Axios to make a call to the API
            // let url = this.$store.state.authorizeUrl;
            // // console.log(url);
            // const { data } = await axios.get(url, {
            //     headers: {
            //         Authorization: `Bearer ${token}`
            //     }
            // });

            // console.log(data);

            // this.apiMessage = data;
        }
    }
};
</script>